export default __webpack_public_path__ + "static/media/vector.5135a998.svg";